module.exports = __webpack_public_path__ + "static/media/mapa-a11.a0a1c418.png";